import React from 'react';
import PropTypes from 'prop-types';
import ProHomepage from './ProHomepage';
import translations from '../../translations/en.json';
import '@fiverr/i18n/singleton';
import { reportPageView } from './lib/reportEvent';

export default class Index extends React.Component {
    constructor(props) {
        super(props);
        i18n.add(translations);
    }

    componentDidMount() {
        const { requestContext } = this.props;
        reportPageView(requestContext);
    }

    render() {
        const {
            sections,
            viewObject,
            requestContext
        } = this.props;

        return (
            <ProHomepage sections={sections}
                viewObject={viewObject}
                requestContext={requestContext}/>
        );
    }
}

Index.propTypes = {
    sections: PropTypes.array,
    viewObject: PropTypes.object,
    requestContext: PropTypes.object
};

Index.defaultProps = {
    sections: [],
    viewObject: {},
    requestContext: {}
};



// WEBPACK FOOTER //
// ./src/common/HomePage/index.js